import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { IJurisdiction } from 'interfaces/jurisdiction.interface';

export interface IJurisdictionsState {
  state: QueryState;
  jurisdictions: Nullable<IJurisdiction[]>;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const JurisdictionsEmptyState: IJurisdictionsState = {
  state: QueryState.UNDEFINED,
  jurisdictions: [],
  error: null,
  accessToken: undefined
};
